import { createTheme } from "@mui/material";

const DiactiveTheme = createTheme({
  palette: {
    primary: {
      main: "#30b8bf"
    },
    success: {
      main: "#4caf50"
    },
    warning: {
      main: "#FFBF00"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "#fff"
        }
      }
    }
  }
});

export const AppBgColor = "#431015";

export default DiactiveTheme;